import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  return <div className="flex flex-col min-h-screen" data-id="element-112" data-mp="kzvfhkw84wcz">
      <Navbar data-id="element-113" data-mp="zxxklziwlpwc" />
      <main className="flex-grow" data-id="element-114" data-mp="zwctykzpmr3r">
        <Outlet data-id="element-115" data-mp="zvbg68rb7qic" />
      </main>
      <Footer data-id="element-116" data-mp="uykrix1fvmlb" />
    </div>;
}